module.exports = __webpack_public_path__ + "img/dropsIcon.ac5232d.png";